const license = {
    not_installed: 'لا يوجد ترخيص مثبّت على هذا المثيل.',
    invalid_key: 'مفتاح الترخيص غير صالح أو تم التلاعب به.',
    expired_key: 'انتهت صلاحية مفتاح الترخيص. احصل على مفتاح جديد وثبّته مرة أخرى.',
};
export default Object.freeze(license);
